import { StyleSheet } from 'react-native';
import { WARMUP_COLORS, WARMUP_HUB } from '../../../src/quiz/constants/warmup.constants';

export const coinDotStyles = StyleSheet.create({
  coinDot: {
    width: 14,
    height: 14,
    borderRadius: 9999,
    backgroundColor: WARMUP_COLORS.amber,
    borderWidth: 1.2,
    borderColor: WARMUP_HUB.coinBorder,
  },
});
